import React from "react";
import { buildAutomationChildTestId, resolveAutomationTestId } from "../../InputField/testId";

const InputBar = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  required = false,
  disabled = false,
  className = "",
  inputProps = {},
  onBlur,
  error,
  showError = false,
  testId,
  id,
  "data-testid": dataTestId,
}) => {
  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  const handleBlur = (event) => {
    if (type === "text" && onChange) {
      const trimmed = event.target.value.trim();
      if (trimmed !== event.target.value) {
        onChange(trimmed);
      }
    }
    onBlur?.(event);
  };

  const isError = Boolean(showError && error);
  const fieldTestId = resolveAutomationTestId(dataTestId, testId, id);

  return (
    <div className={`account-search-input ${className}`.trim()} data-testid={fieldTestId}>
      {label ? <div className="account-search-dropdown__label">{label}</div> : null}
      <input
        className={`account-search-input__control ${isError ? "is-error" : ""}`.trim()}
        type={type}
        value={value ?? ""}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        required={required}
        aria-required={required}
        aria-invalid={isError}
        data-testid={buildAutomationChildTestId(fieldTestId, "input")}
        {...inputProps}
      />
      {isError ? (
        <div className="account-search-field__error" data-testid={buildAutomationChildTestId(fieldTestId, "error")}>
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default InputBar;
